// extracted by mini-css-extract-plugin
module.exports = {"frame":"JoinForm_frame__ec6sB","logo":"JoinForm_logo__2fFYv","escape":"JoinForm_escape__EOJX4"};